import { useDocumentResolverContext } from '../contexts/DocumentResolverContext/hooks/useDocumentResolverContext.hook';
import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDocNombreTotalPages = ({
  enabled,
}: Readonly<ResolverParameters>): ResolverResult<number> => {
  const { printerSettings } = useDocumentResolverContext();

  if (!enabled) {
    return {
      data: undefined,
      error: null,
      isLoading: false,
      isSuccess: false,
    };
  }

  return {
    data: {
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      generated: parseInt(printerSettings?.totalDisplayPageCount || '999', 10),
    },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
